export default __webpack_public_path__ + "static/media/j42.2454c448.jpg";